import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormGroup } from 'react-bootstrap';
import { LoaderButton, ContinueLabel } from 'ctia-ui';
import { submitWizardStep } from 'actions/wizard';
import {
  createNewBillingPoc,
  createNewBillingAddress,
  fetchPocs,
  cleanPocInfo,
  updateRequest
} from 'actions/request';
import { startPreloader, finishPreloader } from 'actions/preloader';
import { showNotice } from 'actions/notifier';
import { updateBillingInfo } from 'actions/billing';
import { notifyMessages } from 'helpers/NotifyHelper';
import {
  validateBillingPoc,
  validateBillingAddress
} from 'helpers/ValidatorHelper';

class BillingSubmit extends Component {
  validate() {
    return this.validatePoc() && this.validateAddress();
  }

  validatePoc() {
    const { request } = this.props;
    const { billingPocId } = request;
    return billingPocId > 0 ? true : validateBillingPoc(request);
  }

  validateAddress() {
    const { request } = this.props;
    const { billingAddressId } = request;
    return billingAddressId > 0 ? true : validateBillingAddress(request);
  }

  createPoc = () => {
    const {
      user,
      request,
      createNewBillingPoc,
      startPreloader,
      finishPreloader
    } = this.props;

    startPreloader();

    request.billingPocId
      ? this.createAddress()
      : createNewBillingPoc(
          request,
          user.requestOwnerCompanyId,
          this.createAddress,
          finishPreloader
        );
  };

  createAddress = () => {
    const {
      user,
      request,
      createNewBillingAddress,
      finishPreloader
    } = this.props;

    // set callback function regarding request exists or not
    const callback = request.id ? this.updatePocCallback : this.onSubmitWizard;

    request.billingAddressId
      ? callback()
      : createNewBillingAddress(
          request,
          user.requestOwnerCompanyId,
          callback,
          finishPreloader
        );
  };

  updatePurchaseNumber = () => {
    const { id, billingOrderNum } = this.props.request;
    this.props.updateRequest({
      id,
      purchaseorder: _.trim(billingOrderNum)
    });
  };

  onSaveClick = () => {
    this.updatePurchaseNumber();
    this.createPoc();
  };

  updatePocCallback = () => {
    const {
      request,
      updateBillingInfo,
      finishPreloader,
      showNotice,
      fetchPocs,
      user
    } = this.props;

    updateBillingInfo(request).then(
      fetchPocs(user.requestOwnerCompanyId).then(() => {
        finishPreloader();
        showNotice(notifyMessages.requestUpdatedSuccessfully);
      })
    );
  };

  onSubmitWizard = () => {
    this.props.finishPreloader();
    return this.props.submitWizardStep(this.props.wizard);
  };

  render() {
    const { request, user } = this.props;

    const isNewRequest = _.isUndefined(request.id);
    const isEditable = user.canEditRequest && request.id > 0 && !request.isPaid;

    return (
      <FormGroup>
        <Col sm={3} />
        <Col sm={4}>
          <LoaderButton
            bsStyle="default"
            text="Save changes"
            disabled={!this.validate()}
            isLoading={request.isLoading}
            onClick={this.onSaveClick}
            show={isEditable}
          />
        </Col>
        <Col sm={5} className="text-right">
          <LoaderButton
            bsStyle="info"
            text={<ContinueLabel />}
            disabled={!this.validate()}
            isLoading={request.isLoading}
            onClick={this.createPoc}
            show={isNewRequest}
          />
        </Col>
      </FormGroup>
    );
  }
}

function mapStateToProps({ request, user, wizard }) {
  return { request, user, wizard };
}

export default connect(
  mapStateToProps,
  {
    startPreloader,
    finishPreloader,
    fetchPocs,
    submitWizardStep,
    createNewBillingPoc,
    createNewBillingAddress,
    updateBillingInfo,
    cleanPocInfo,
    showNotice,
    updateRequest
  }
)(BillingSubmit);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/BillingSubmit.js